/* eslint-disable import/prefer-default-export */
import { takeLatest, put, call, all } from 'redux-saga/effects' // eslint-disable-line
import updatePayActions, {
    updatePayTypes,
} from '../../../redux/demande/updatePay'
import { Get } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* updatePaySagas({ response }) {
    const { orderId, intl } = response
    try {
        const res = yield Get(`demande/finalize-paiement/${orderId}`)
        if (res.status === 200) {
            yield put(updatePayActions.updatePaySuccess(res.data.data))
            yield put(
                alertActions.alertShow(true, {
                    onConfirm: null,
                    warning: false,
                    info: false,
                    error: false,
                    success: true,
                    message: intl.formatMessage({
                        id: 'successSagaMessage',
                    }),
                    title: intl.formatMessage({
                        id: 'successSagaTitle',
                    }),
                })
            )
        } else {
            console.log(res)
            yield put(updatePayActions.updatePayFailure(res.data.data))
        }
    } catch (error) {
        yield put(updatePayActions.updatePayFailure(error))
    }
}

export function* updatePaySaga() {
    yield takeLatest(updatePayTypes.UPDATE_PAY_REQUEST, updatePaySagas)
}
